import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StructuredDataComponent } from './structured-data.component';

@NgModule({
  imports: [CommonModule, StructuredDataComponent],
  exports: [StructuredDataComponent],
})
export class StructuredDataModule {}
